export enum AgreementCategory {
  all = 'all',
  formation = 'formation',
  operating = 'operating',
  shareholder = 'shareholder',
  board = 'board',
  employment = 'employment',
  investor = 'investor',
  compliance = 'compliance',
}

export interface CategoryInfo {
  key: AgreementCategory
  label: string
  description: string
  storagePath: string
}

export const categoryInfo: Record<AgreementCategory, CategoryInfo> = {
  [AgreementCategory.all]: {
    key: AgreementCategory.all,
    label: 'All Documents',
    description: 'All governing documents',
    storagePath: 'governing',
  },
  [AgreementCategory.formation]: {
    key: AgreementCategory.formation,
    label: 'Formation',
    description: 'Articles of Incorporation, Bylaws, Certificates of Formation',
    storagePath: 'governing/formation',
  },
  [AgreementCategory.operating]: {
    key: AgreementCategory.operating,
    label: 'Operating Agreements',
    description: 'LLC Operating Agreements, Partnership Agreements',
    storagePath: 'governing/operating',
  },
  [AgreementCategory.shareholder]: {
    key: AgreementCategory.shareholder,
    label: 'Shareholder Agreements',
    description: 'Shareholder Agreements, Voting Agreements, ROFR',
    storagePath: 'governing/shareholder',
  },
  [AgreementCategory.board]: {
    key: AgreementCategory.board,
    label: 'Board Resolutions',
    description: 'Board Resolutions, Written Consents, Meeting Minutes',
    storagePath: 'governing/board',
  },
  [AgreementCategory.employment]: {
    key: AgreementCategory.employment,
    label: 'Employment Contracts',
    description: 'Employment Agreements, Consulting Agreements, NDAs',
    storagePath: 'governing/employment',
  },
  [AgreementCategory.investor]: {
    key: AgreementCategory.investor,
    label: 'Investor Agreements',
    description: 'Investment Agreements, SAFEs, Convertible Notes, Side Letters',
    storagePath: 'governing/investor',
  },
  [AgreementCategory.compliance]: {
    key: AgreementCategory.compliance,
    label: 'Compliance & Filings',
    description: 'Government Filings, Annual Reports, Tax Documents',
    storagePath: 'governing/compliance',
  },
}

export const categoryList = Object.values(categoryInfo)

export const getCategoryFromPath = (categoryParam?: string): AgreementCategory => {
  if (!categoryParam) return AgreementCategory.all
  const category = categoryParam as AgreementCategory
  return categoryInfo[category] ? category : AgreementCategory.all
}

export const getStoragePath = (category: AgreementCategory): string => {
  return categoryInfo[category]?.storagePath || 'governing'
}

export const getCategoryLabel = (category: AgreementCategory): string => {
  return categoryInfo[category]?.label || 'Unknown'
}

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

export const formatDate = (date: string | Date): string => {
  const d = new Date(date)
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}
